import { DialogContent, RedeemForm } from "@/components";

export interface RedeemFormDialogProps {
    onClose?: () => void;
    initialRedeemAmount?: number;
}

export function RedeemFormDialog({ initialRedeemAmount }: RedeemFormDialogProps) {
    return (
        <DialogContent>
            <RedeemForm initialAmount={initialRedeemAmount} isDialog />
        </DialogContent>
    );
}
